// extracted by mini-css-extract-plugin
export default {"colorDropdown":"StageColor_colorDropdown__Z52Ws","errorIcon":"StageColor_errorIcon__jF4Ji","errorColor":"StageColor_errorColor__EDhAP","disabled":"StageColor_disabled__-JRko"};